// extracted by mini-css-extract-plugin
export default {"loading":"VL8E+2JLnAZm+YNYY7pNYA=="};